export const ORDER_PAGE         = Symbol('ORDER_PAGE');
export const RESULTS_PAGE       = Symbol('RESULTS_PAGE');
export const CONFIRMATION_PAGE  = Symbol('CONFIRMATION_PAGE');
export const HOME_PAGE          = Symbol('HOME_PAGE');
export const DETAILS_PAGE       = Symbol('DETAILS_PAGE');
export const CREDIT_CARD_PAGE   = Symbol('CREDIT_CARD_PAGE');